export const enum DaccaActionTypes {
  OPEN_DACCA = '@@dacca/OPEN_DACCA',
  IMPORT_LINES_FROM_DACCA = '@@dacca/IMPORT_LINES_FROM_DACCA',
  IMPORT_LINES_FROM_DACCA_SUCCESS = '@@dacca/IMPORT_LINES_FROM_DACCA_SUCCESS',
  IMPORT_LINES_FROM_DACCA_FAIL = '@@dacca/IMPORT_LINES_FROM_DACCA_FAIL',
  FETCH_DACCA_CALCULATIONS = '@@dacca/FETCH_DACCA_CALCULATIONS',
  FETCH_DACCA_CALCULATIONS_SUCCESS = '@@dacca/FETCH_DACCA_CALCULATIONS_SUCCESS',
  FETCH_DACCA_CALCULATIONS_FAIL = '@@dacca/FETCH_DACCA_CALCULATIONS_FAIL',
  FETCH_DACCA_TOKEN = '@@dacca/FETCH_DACCA_TOKEN',
  FETCH_DACCA_TOKEN_SUCCESS = '@@dacca/FETCH_DACCA_TOKEN_SUCCESS',
  FETCH_DACCA_TOKEN_FAIL = '@@dacca/FETCH_DACCA_TOKEN_FAIL',
}

export interface  DaccaState {
  readonly daccaCalculations: DaccaCalculation[];
  readonly loading: boolean;
  readonly daccaBaseURL: string;
}

export interface DaccaCalculation {
  readonly calculationStatusTC: string;
  readonly calculationUsageTC: string;
  readonly calculationVersionID: number;
  readonly externalReference: string;
}

export interface OverallTotal {
  readonly total: Total;
  readonly vatPercentage: number;
}

export interface Total {
  readonly total: number;
  readonly totalDIY: number;
  readonly totalLabour: number;
  readonly totalMaterial: number;
}
